module.exports = __webpack_public_path__ + "img/logoT.5fcf54ad.png";